var mix = require('@antv/util/lib/mix');

var Adjust =
/*#__PURE__*/
function () {
  var _proto = Adjust.prototype;

  _proto._initDefaultCfg = function _initDefaultCfg() {
    this.adjustNames = ['x', 'y']; // 调整的维度，默认,x,y都做调整
  };

  function Adjust(cfg) {
    this._initDefaultCfg();

    mix(this, cfg);
  }
  /**
   * @override
   */


  _proto.processAdjust = function processAdjust()
  /* dataArray */
  {};

  return Adjust;
}();

module.exports = Adjust;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_adjust@0.1.1@@antv/adjust/lib/base.js
// module id = 33
// module chunks = 0 1 2